import React, { useState, useEffect } from "react";
import Header from "../../Components/Header";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import LoaderForSearch from "../../Components/Common/LoaderForSearch";
import $ from "jquery";
import {
  AESEncryption,
  ApiResDecrypt,
  mobileNumberEnc,
} from "../../CommonMethhods/CommonMethods";
import axios from "axios";
import {
  Client_Search,
  Dashboard_Client_Report,
} from "../../Configuration/API_URL";
// import OtpInput from "react-otp-input";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import OtpInput from "../LeadCreation/OtpInput";
import SmallLoader from "../../Components/Common/smallLoader";
import { useDebounce } from "../../Components/useDebounce";

const CMLReport = () => {
  const storeToken = localStorage.getItem("ssoToken");
  const [clientName, setClientName] = useState("");
  const [clientCode, setClientCode] = useState("");
  const [page, setPage] = useState(1);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [scroll, setScroll] = useState(false);
  const [nameError, setNameError] = useState("");
  const [show, setShow] = useState(false);
  const [disableDownload, setDisableDownload] = useState(true);
  const [seconds, setSeconds] = useState(30);
  const [minutes, setMinutes] = useState(0);
  const [otpValues, setOtpValues] = useState(Array(4).fill(""));
  const [isOtpComplete, setIsOtpComplete] = useState(false);
  const [clientMobile, setClientMobile] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingConfirm, setLoadingConfirm] = useState(false);
  const [dpIds, setDpIds] = useState([]);
  const [selectedDpId, setSelectedDpId] = useState("");
  const [selectedUcc, setSelectedUcc] = useState("");

  const debouncedValue = useDebounce(clientCode, 1000);

  useEffect(()=>{
    handleClientCode(debouncedValue)
  }, [debouncedValue])

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  async function searchApiDetail(e) {
    $(".write-search.morningLimit").addClass("show-result scroll-table");
    setScrollLoader(true);
    let payloadValue = {
      keyword: e.toUpperCase(),
      Status: "",
      PageNo: page,
      PageSize: 10,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getSearchDetail = await axios.post(
        Client_Search.Search_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );

      const res = ApiResDecrypt(getSearchDetail?.data);

      if (res.message === "Client does not exist.") {
        setClientList([
          { clientname: "Client does not exist.", clientCode: null },
        ]);
      } else {
        if (scroll == true) {
          setClientList((prev) => {
            return [...prev, ...res.data.clients];
          });
          setNameError("");
        } else {
          setClientList(res.data.clients);
          setNameError("");
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setScrollLoader(false);
    }
  }

  function clientSet(name, code, i) {
    if (name === "Client does not exist.") {
      $(".write-search.morningLimit").addClass("show-result scroll-table");
    } else {
      $(".write-search.morningLimit").removeClass("show-result");
      setClientList([]);
      setClientName(name);
      setClientCode(code);
      setScrollLoader(false);
    }
  }

  const handleClientCode = (data) => {
    setScrollLoader(false);
    setNameError("");
    if (data) {
      setDisableDownload(false);
      setClientList([]);
      setScroll(false);
      // let value = data.toUpperCase();
      // value = value.replace(/[^A-Z0-9 ]/gi, "");
      // value = value.replace(/\s{2,}/g, " ");
      // value = value.replace(/^\s+/, "");
      // setClientCode(value);
      if (data?.length > 3) {
        setPage(1);
        setClientList([]);
        setScroll(false);
        searchApiDetail(data);
      }
    } else {
      //   setNameError("Client Code is required");
      setDisableDownload(true);
      setSelectedDpId("");
      setDpIds([]);
      setClientList([]);
      setPage(1);
      setClientName("");
      setClientCode("");
      setSelectedUcc("");
      setScroll(false);
      $(".write-search.morningLimit").removeClass("show-result");
    }
    $(".write-search.morningLimit-li").click(function () {
      $(".write-search.morningLimit").addClass("show-result scroll-table");
    });
  };

  const handleScroll = async () => {
    setScroll(true);
    const a = document.querySelector("#morninglimit-scroll");
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight) {
      setPage((prev) => prev + 1);
      setScrollLoader(true);

      searchApiDetail(clientCode);
    }
  };

  const getDpIds = async () => {
    const payloadValue = {
      clientCode,
    };
    const encPayload = AESEncryption(payloadValue);
    try {
      let response = await axios.post(
        Dashboard_Client_Report.CMLGetDPs,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      response = ApiResDecrypt(response?.data);
      if (response.status === 0) {
        setDpIds(response.data.dpIds);
      } else {
        setDpIds([]);
        toast.error(response.message);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleOtpComplete = (status) => {
    setIsOtpComplete(status);
  };

  const sendOtp = async (download = false) => {
    download === true ? setLoading(true) : setLoading(false);
    const payloadValue = {
      clientCode,
    };
    const encPayload = AESEncryption(payloadValue);
    try {
      let res = await axios.post(
        Dashboard_Client_Report.CMLSendOtp,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      res = ApiResDecrypt(res?.data);
      if (res.status === 0) {
        setOtpValues(Array(4).fill(""));
        setClientMobile(res.data.mobileNo);
        setSeconds(30);
        setShow(true);
      } else if (res.status === 1) {
        toast.error(res.message);
        if (res.message.includes("OTP limit exceeded")) {
          setShow(false);
        } else {
          setOtpValues(Array(4).fill(""));
          setTimeout(() => {
            document.getElementById("otp-input-0")?.focus();
          }, 100);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const verifyOtpDownloadCml = async () => {
    setLoadingConfirm(true);
    const otp = otpValues.join("");
    const payloadValue = {
      dpId: selectedDpId,
      mobileNo: clientMobile,
      otp,
    };
    const encPayload = AESEncryption(payloadValue);
    try {
      let res = await axios.post(
        Dashboard_Client_Report.CMLValidateOtp,
        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      res = ApiResDecrypt(res?.data);
      if (res.status === 0) {
        setShow(false);
        window.open(res.data, "_blank", "noopener,noreferrer");
      } else {
        toast.error(res.message);
        if (res.message === "Failed to fetch cml pdf") {
          setShow(false);
        } else {
          setOtpValues(Array(4).fill(""));
          setTimeout(() => {
            document.getElementById("otp-input-0")?.focus();
          }, 100);
        }
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingConfirm(false);
    }
  };

  useEffect(() => {
    if (!selectedUcc) return;
    getDpIds();
  }, [selectedUcc]);

  useEffect(() => {
    if (dpIds && dpIds.length > 0) {
      setSelectedDpId(dpIds[0]);
    } else {
      setSelectedDpId("");
    }
  }, [dpIds]);

  return (
    <div>
      <Header portal={"RM"} />
      <SingleSignOnSideBar />
      <main id="main-content" className="reports" style={{ height: "317px" }}>
        <div className="card-box">
          <div>
            <h2 className="report-title">CML Report</h2>
          </div>
          <div className="row input-field-wrapper d-flex">
            <div className="col-md-4 col-sm-6">
              <div className="form-group">
                <label className="form-label">
                  UCC Search <span style={{ color: "red" }}>*</span>
                </label>
                <div className="input-text-wrapper align-items-center">
                  <input
                    type="text"
                    className="input-text form-control"
                    placeholder="Search by UCC/Name"
                    value={clientCode}
                    onChange={(e) => {
                      setClientCode(e?.target?.value?.toUpperCase())
                      // handleClientCode(e);
                    }}
                    onInput={(e) => {
                      const start = e.target.selectionStart;
                      const end = e.target.selectionEnd;
                      let input = e.target.value;
                      input = input
                          .toUpperCase()
                          .replace(/[^A-Z0-9\s]/g, "")
                          .replace(/\s+/g, " ")
                          .trimStart()
                          .slice(0, 100);

                      e.target.value = input;
                      e.target.setSelectionRange(start, end);
                      
                  }}
                  />

                  <ul
                    className="write-search morningLimit border-0"
                    id="morninglimit-scroll"
                    onScroll={handleScroll}
                    style={{ width: "93%" }}
                  >
                    {clientList.map((item, i) => (
                      <li
                        key={i}
                        onClick={() => {
                          clientSet(item.clientname, item.clientCode, i);
                          setSelectedUcc(item.clientCode);
                        }}
                      >
                        <div> {item.clientname}</div>
                        <div>{item.clientCode}</div>
                      </li>
                    ))}
                    {scrollLoader && (
                      <div className="loader-center">
                        <LoaderForSearch />
                      </div>
                    )}
                  </ul>
                </div>
                <span className="to-date-error">{nameError}</span>
              </div>
            </div>

            <div className="col-md-4 col-sm-6">
              <div className="form-group">
                <label className="form-label">
                  Client ID <span style={{ color: "red" }}>*</span>
                </label>
                {/* <div className="input-text-wrapper align-items-center"> */}
                <select
                  value={selectedDpId}
                  onChange={(e) => setSelectedDpId(e.target.value)}
                  disabled={dpIds.length <= 1}
                  style={
                    dpIds.length <= 1
                      ? {
                          backgroundColor: "#fafafa",
                          color: "#6c757d",
                        }
                      : {}
                  }
                >
                  {dpIds.length === 0 && (
                    <option value="">Select Client Code</option>
                  )}
                  {dpIds?.map((id, i) => (
                    <option key={i} value={id}>
                      {id}
                    </option>
                  ))}
                </select>
                {/* </div> */}
              </div>
            </div>

            <div
              className="text-center search-btn-wrapper mt-0 "
              style={{ marginBottom: "8px" }}
            >
              <button
                className={"send-message"}
                onClick={() => sendOtp(true)}
                disabled={disableDownload || !selectedDpId}
                style={loading ? { width: "140px" } : {}}
              >
                {loading ? (
                  <div className="d-flex justify-content-center">
                    <SmallLoader />
                  </div>
                ) : (
                  "Download"
                )}
              </button>
            </div>
          </div>
        </div>
      </main>
      <Modal
        show={show}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="otp-modal setting-model"
        // backdrop="static"
        keyboard={false}
      >
        <Modal.Header className="modal-header">
          <Modal.Title id="contained-modal-title-vcenter modal-title">
            <div className="figure-inlac">
              {/* <h2 className="h2-css-all">Enter OTP</h2> */}
            </div>
          </Modal.Title>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={() => setShow(false)}
          >
            <span className="icon-close"></span>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div className="inactive-modal-table otp-modal-body">
            <h2 className="h2-css-all">Enter OTP</h2>
            <div className="wrap-otp-text">
              <p className="otp-text">
                A one-time password has been sent to client registered mobile
                number <>+91 {mobileNumberEnc(clientMobile)}</>
              </p>
            </div>
            <OtpInput
              otpValues={otpValues}
              setOtpValues={setOtpValues}
              onVerify={verifyOtpDownloadCml}
              otpBtn={sendOtp}
              seconds={seconds}
              minutes={minutes}
              onOtpComplete={handleOtpComplete}
            />

            <div className="nominee-btn-wrapper">
              <div className="wrap-button">
                <button
                  type="submit"
                  className="default-btn-wrap"
                  onClick={() => setShow(false)}
                >
                  Cancel
                </button>
              </div>
              <div className="wrap-button">
                <button
                  type="submit"
                  className={`${
                    !isOtpComplete ? "disable-btn val-btn-wrap" : "val-btn-wrap"
                  }`}
                  disabled={!isOtpComplete}
                  onClick={verifyOtpDownloadCml}
                >
                  {loadingConfirm ? (
                    <div className="d-flex justify-content-center">
                      <SmallLoader />
                    </div>
                  ) : (
                    "Confirm"
                  )}
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default CMLReport;
